import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
  Switch,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useColorModeValue,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import CardHeader from 'components/Card/CardHeader';
import { useUserActions } from 'hooks/useUserActions';
import { useReportPermissionActions } from 'hooks/useReportPermissionActions';
import { useDataPermissionActions } from 'hooks/useDataPermissionActions';
import React, { useEffect, useRef, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { usersAtom } from 'state/users';
import { columnsDataUser } from 'variables/columnsData';
import { useRolePermissionActions } from 'hooks/useRolePermissionActions';
import { rolesAtom, totalRow } from 'state/roles-permissions';
import { useSiteActions } from 'hooks/useSiteActions';
import { sitesAtom } from 'state/sites';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Select as ReactSelect } from 'chakra-react-select';
import { useHistory } from 'react-router-dom';
import { AddIcon } from '@chakra-ui/icons';
import { checkForbidden } from 'helpers/checkForbidden';
import { BsSearch } from 'react-icons/bs';
import { RxReset } from 'react-icons/rx';
import SearchTable2 from 'components/Tables/SearchTable2';

function DataTablesUser() {
  const textColor = useColorModeValue('gray.700', 'white');
  const userActions = useUserActions();
  const users = useRecoilValue(usersAtom);
  const roleAction = useRolePermissionActions();
  const siteAction = useSiteActions();
  const totalRows = useRecoilValue(totalRow);
  const roles = useRecoilValue(rolesAtom);
  const sites = useRecoilValue(sitesAtom);
  const [isCreate, setIsCreate] = useState(true);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [currentID, setCurrentID] = useState();
  const [isFetching, setIsFetching] = useState(false);
  const [newUser, setNewUser] = useState([]);
  const [refreshPagingDefault, setRefreshPagingDefault] = useState(false);

  const chakraStyles = {
    dropdownIndicator: (provided, state) => ({
      ...provided,
      p: 0,
      w: '20px',
    }),
    container: (provided, state) => ({
      ...provided,
      minWidth: '200px',
    }),
    menu: (provided, state) => ({
      ...provided,
      zIndex: 15,
    }),
  };
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required('This field is required')
      .email('Invalid Email'),
    fullname: Yup.string().required('This field is required'),
    phone: Yup.string().required('This field is required'),
    sites: Yup.array().min(1, 'This field is required').required('This field is required'),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const {
    register,
    handleSubmit,
    setError,
    formState,
    reset,
    setValue,
    control,
  } = useForm(formOptions);
  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    control: controlSearch,
    reset: resetSearch,
    setValue: setValueSearch,
    watch,
  } = useForm();
  const { errors, isSubmitting } = formState;
  const toast = useToast();
  const fullNameSearch = watch('fullnameSearch');
  const emailSearch = watch('emailSearch');
  const statusSearch = watch('statusSearch');
  const roleSearch = watch('roleSearch');
  const typeSearch = watch('typeSearch');

  const UserTypeOptions = [
    { Id: '', Name: 'All' },
    { Id: '1', Name: 'Backoffice' },
    { Id: '2', Name: 'Report' },
    { Id: '3', Name: 'Both' },
  ];

  const recallApi = async (fetchDataOptions) => {
    setIsFetching(true);

    const roleIDArray = roleSearch?.map((i) => i.id) ?? [];
    const roleIDs = roleIDArray.toString();
    await userActions.getAllUsers(
      {
        role_ids: roleIDs,
        fullname: fullNameSearch,
        email: emailSearch,
        status: statusSearch ? statusSearch : 1,
        type: typeSearch || undefined,
        sort_type: fetchDataOptions.sort_type,
        sort_field: fetchDataOptions.sort_field,
      },
      fetchDataOptions.pageIndex,
      fetchDataOptions.pageSize
    );
    setIsFetching(false);
  };

  useEffect(() => {
    if (users) {
      const newUsers = users.map((i) => ({
        ...i,
        typeSwitch: 'user',
        filters: {
          role_ids: '',
          fullname: fullNameSearch,
          email: emailSearch,
          status: statusSearch,
        },
      }));
      setNewUser(newUsers);
    }
  }, [users]);

  useEffect(() => {
    roleAction.getAllRoles({ name: '', status: 1 }, '', '');
    siteAction.getAllSites({ name: '', status: 1 }, '', '');
  }, []);

  const history = useHistory();

  function showDetail(val) {
    history.push(`/admin/setting/user-detail/${val}`);
  }

  async function edit(val) {
    await userActions.getUserById(val).then((res) => {
      if (res.status === 200) {
        setValue('email', res.data.data.email);
        setValue('fullname', res.data.data.fullname);
        setValue('phone', res.data.data.phone);
        setValue('department', res.data.data.department ?? '');
        setValue('roles', res.data.data.role);
        setValue('sites', res.data.data.sites);
        setValue('isActive', res.data.data.status === 1 ? true : false);
        setCurrentID(res.data.data.id);
      }
    });
    setIsCreate(false);
    onOpen();
  }

  async function onSubmitSearch({
    fullnameSearch,
    emailSearch,
    statusSearch,
    roleSearch,
    typeSearch,
  }) {
    setIsFetching(true);
    const roleIDArray = roleSearch?.map((i) => i.id) ?? [];
    const roleIDs = roleIDArray.toString();
    await userActions.getAllUsers(
      {
        role_ids: roleIDs,
        fullname: fullnameSearch,
        email: emailSearch,
        status: statusSearch,
        type: typeSearch || undefined,
      },
      0,
      localStorage && localStorage.getItem('currentPageSizeStore')
        ? localStorage.getItem('currentPageSizeStore')
        : 10
    );
    setRefreshPagingDefault(true);
    setIsFetching(false);
  }

  async function onSubmit({ email, fullname, phone, department, isActive, roles, sites }) {
    try {
      const roleIDs = roles?.map((i) => i.id) ?? [];
      const siteIDs = sites?.map((i) => i.id) ?? [];
      if (isCreate) {
        await userActions.createUser({
          email,
          fullname,
          phone,
          department,
          role_ids: roleIDs,
          site_ids: siteIDs,
          status: isActive ? 1 : 2,
          type: '1',
        });
        toast({
          description: `Create user successful`,
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
      } else {
        await userActions.updateUser(
          {
            email,
            fullname,
            phone,
            department,
            role_ids: roleIDs,
            site_ids: siteIDs,
            status: isActive ? 1 : 2,
            type: '1',
          },
          currentID
        );
        setValue('roles', []);
        setValue('sites', []);
        toast({
          description: `Edit user successful`,
          status: 'success',
          duration: 5000,
          isClosable: true,
          position: 'top-right',
        });
      }
      reset();
      const currentPageSizeStore =
        localStorage && localStorage.getItem('currentPageSizeStore');
      await userActions.getAllUsers(
        {
          role_ids: roleIDs,
          fullname: fullNameSearch,
          email: emailSearch,
          status: statusSearch,
        },
        0,
        currentPageSizeStore ?? 10
      );
      onClose();
    } catch (err) {
      setError('apiError', {
        message: err.response?.data?.meta?.message ?? err.message,
      });
    }
  }

  const UserStatus = [
    { Id: '0', Name: 'All' },
    { Id: '1', Name: 'Active' },
    { Id: '2', Name: 'InActive' },
  ];

  // --- Report Permission modal ---
  const reportPermActions = useReportPermissionActions();
  const { isOpen: isPermOpen, onOpen: onPermOpen, onClose: onPermClose } = useDisclosure();
  const [permUser, setPermUser] = useState(null);
  const [reports, setReports] = useState([]);
  const [reportTotal, setReportTotal] = useState(0);
  const [isFetchingReports, setIsFetchingReports] = useState(false);
  const [isSavingPerm, setIsSavingPerm] = useState(false);
  // permMap: { [report_id]: { can_view, can_export, can_filter, can_save_filter } }
  const [permMap, setPermMap] = useState({});
  const columnsDataReportPerm = [
    { header: 'Report', accessorKey: 'name' },
    ...['can_view', 'can_export', 'can_filter', 'can_save_filter'].map((field) => ({
      header: field.replace('can_', '').replace('_', ' ').replace(/^\w/, c => c.toUpperCase()),
      accessorKey: field,
      size: 100,
      Cell: ({ row, table }) => {
        const canEdit = checkForbidden(144) || checkForbidden(145);
        return (
          <Checkbox
            isChecked={!!table.options.meta?.permMap?.[row.original.id]?.[field]}
            onChange={() => table.options.meta?.togglePerm(row.original.id, field)}
            isDisabled={!canEdit}
          />
        );
      },
    })),
  ];

  async function openReportPermModal(user) {
    setPermUser(user);
    setPermMap({});
    setReports([]);
    setReportTotal(0);
    onPermOpen();
    // Load permissions của user trước (1 lần), reports load qua SearchTable2's loadData
    const pRes = await reportPermActions.getPermissionsByReport(null, 0, 9999, user.id);
    if (pRes?.status === 200) {
      const map = {};
      (pRes.data.data || []).forEach((p) => {
        map[p.report_id] = {
          can_view: p.can_view,
          can_export: p.can_export,
          can_filter: p.can_filter,
          can_save_filter: p.can_save_filter,
        };
      });
      setPermMap(map);
    }
  }

  async function recallReportsForPerm(fetchDataOptions) {
    if (!checkForbidden(143)) return;
    setIsFetchingReports(true);
    const res = await reportPermActions.getReports({}, fetchDataOptions.pageIndex, fetchDataOptions.pageSize);
    if (res?.status === 200) {
      setReports(res.data.data || []);
      setReportTotal(res.data.meta?.total || 0);
    }
    setIsFetchingReports(false);
  }

  function togglePerm(reportId, field) {
    setPermMap((prev) => ({
      ...prev,
      [reportId]: {
        can_view: false,
        can_export: false,
        can_filter: false,
        can_save_filter: false,
        ...prev[reportId],
        [field]: !prev[reportId]?.[field],
      },
    }));
  }

  async function saveReportPerms() {
    setIsSavingPerm(true);
    try {
      const items = Object.entries(permMap).map(([report_id, p]) => ({
        user_id: permUser.id,
        user_email: permUser.email,
        report_id: Number(report_id),
        can_view: !!p.can_view,
        can_export: !!p.can_export,
        can_filter: !!p.can_filter,
        can_save_filter: !!p.can_save_filter,
      }));
      await reportPermActions.bulkUpsertPermissions(items);
      toast({ description: 'Saved report permissions', status: 'success', duration: 3000, isClosable: true, position: 'top-right' });
      onPermClose();
    } catch (err) {
      toast({ description: err?.response?.data?.meta?.message || err.message, status: 'error', duration: 4000, isClosable: true, position: 'top-right' });
    }
    setIsSavingPerm(false);
  }

  // --- Data Permission modal ---
  const dataPermActions = useDataPermissionActions();
  const { isOpen: isDataPermOpen, onOpen: onDataPermOpen, onClose: onDataPermClose } = useDisclosure();
  const [dataPermUser, setDataPermUser] = useState(null);
  const [dataPermList, setDataPermList] = useState([]);
  const [dataPermTotal, setDataPermTotal] = useState(0);
  const [dataPermStatusFilter, setDataPermStatusFilter] = useState('1');
  const [isFetchingDataPerm, setIsFetchingDataPerm] = useState(false);

  // Add/Edit data permission form
  const [isDataPermCreate, setIsDataPermCreate] = useState(true);
  const [editDataPermId, setEditDataPermId] = useState(null);
  const { isOpen: isDataPermFormOpen, onOpen: onDataPermFormOpen, onClose: onDataPermFormClose } = useDisclosure();
  const [locationList, setLocationList] = useState([]);
  const [channelList, setChannelList] = useState([]);
  const [showList, setShowList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [unitSearch, setUnitSearch] = useState('');
  const [unitOffset, setUnitOffset] = useState(0);
  const [unitHasMore, setUnitHasMore] = useState(false);
  const [isFetchingUnits, setIsFetchingUnits] = useState(false);
  const unitPageSize = 100;
  const [dpLocation, setDpLocation] = useState('0');
  const [dpChannel, setDpChannel] = useState('0');
  const [dpShows, setDpShows] = useState([]);
  const [dpUnits, setDpUnits] = useState([]);
  const [isSavingDataPerm, setIsSavingDataPerm] = useState(false);

  // Delegates
  const [delegateList, setDelegateList] = useState([]);
  const [delegateTotal, setDelegateTotal] = useState(0);
  const [delegateStatusFilter, setDelegateStatusFilter] = useState('1');
  const [isFetchingDelegates, setIsFetchingDelegates] = useState(false);
  const { isOpen: isAddDelegateOpen, onOpen: onAddDelegateOpen, onClose: onAddDelegateClose } = useDisclosure();
  const [delegateMemberSelected, setDelegateMemberSelected] = useState(null);
  const [isSavingDelegate, setIsSavingDelegate] = useState(false);
  const [delegateNewStatus, setDelegateNewStatus] = useState(1);

  // ReactSelect user search for delegate
  const DELEGATE_USER_PAGE_SIZE = 100;
  const [delegateUserOptions, setDelegateUserOptions] = useState([]);
  const [delegateUserOffset, setDelegateUserOffset] = useState(0);
  const [delegateUserHasMore, setDelegateUserHasMore] = useState(true);
  const [isLoadingDelegateUsers, setIsLoadingDelegateUsers] = useState(false);
  const delegateUserSearchQuery = useRef('');
  const delegateUserInputTimer = useRef(null);

  async function openDataPermModal(user) {
    setDataPermUser(user);
    setDataPermList([]);
    setDelegateList([]);
    setDataPermStatusFilter('1');
    setDelegateStatusFilter('1');
    onAddDelegateClose();
    setDelegateMemberSelected(null);
    onDataPermOpen();
    loadDataPermissions(user.id, 0, 10, '1');
    loadDelegates(user.id, 0, 10, '1');
    // Load master data
    const [locRes, chanRes, showRes] = await Promise.all([
      dataPermActions.getLocations(),
      dataPermActions.getChannels(),
      dataPermActions.getShows(),
    ]);
    if (locRes?.status === 200) setLocationList(locRes.data.data || []);
    if (chanRes?.status === 200) setChannelList(chanRes.data.data || []);
    if (showRes?.status === 200) setShowList(showRes.data.data || []);
  }

  async function loadDataPermissions(userId, page, pageSize, status) {
    if (!checkForbidden(147)) return;
    setIsFetchingDataPerm(true);
    try {
      const res = await dataPermActions.getDataPermissions(userId, page, pageSize, status);
      if (res?.status === 200) {
        setDataPermList(res.data.data || []);
        setDataPermTotal(res.data.meta?.total || 0);
      }
    } catch (_) {}
    setIsFetchingDataPerm(false);
  }

  async function loadDelegates(managerId, page, pageSize, status) {
    if (!checkForbidden(147)) return;
    setIsFetchingDelegates(true);
    try {
      const res = await dataPermActions.getDelegates(managerId, page, pageSize, status);
      if (res?.status === 200) {
        setDelegateList(res.data.data || []);
        setDelegateTotal(res.data.meta?.total || 0);
      }
    } catch (_) {}
    setIsFetchingDelegates(false);
  }

  async function loadUnits(channelId, search, offset, append = false) {
    if (!channelId || channelId === '0') return;
    setIsFetchingUnits(true);
    try {
      const res = await dataPermActions.getUnits(channelId, search, offset, unitPageSize);
      const data = res?.data?.data || [];
      const total = res?.data?.meta?.total || 0;
      setUnitList((prev) => append ? [...prev, ...data] : data);
      setUnitOffset(offset + data.length);
      setUnitHasMore(offset + data.length < total);
    } catch (_) {
      if (!append) {
        setUnitList([]);
        setUnitOffset(0);
        setUnitHasMore(false);
      }
    }
    setIsFetchingUnits(false);
  }

  async function onDataPermChannelChange(channelId) {
    setDpChannel(channelId);
    setDpUnits([]);
    setUnitList([]);
    setUnitSearch('');
    setUnitOffset(0);
    setUnitHasMore(false);
    if (channelId && channelId !== '0') {
      await loadUnits(channelId, '', 0, false);
    }
  }

  async function onUnitSearch(channelId, search) {
    setUnitSearch(search);
    setUnitOffset(0);
    await loadUnits(channelId, search, 0, false);
  }

  async function onUnitLoadMore(channelId) {
    await loadUnits(channelId, unitSearch, unitOffset, true);
  }

  function openAddDataPerm() {
    setIsDataPermCreate(true);
    setEditDataPermId(null);
    setDpLocation('0');
    setDpChannel('0');
    setDpShows([]);
    setDpUnits([]);
    setUnitList([]);
    setUnitSearch('');
    setUnitOffset(0);
    setUnitHasMore(false);
    onDataPermFormOpen();
  }

  async function openEditDataPerm(perm) {
    setIsDataPermCreate(false);
    setEditDataPermId(perm.id);
    setDpLocation(String(perm.location_id ?? '0'));
    setDpChannel(String(perm.channel_id ?? '0'));
    setDpShows(perm.show_ids || []);
    setDpUnits(perm.unit_ids || []);
    setUnitList([]);
    setUnitSearch('');
    setUnitOffset(0);
    setUnitHasMore(false);
    if (perm.channel_id && perm.channel_id !== 0) {
      await loadUnits(String(perm.channel_id), '', 0, false);
    }
    onDataPermFormOpen();
  }

  async function saveDataPerm() {
    setIsSavingDataPerm(true);
    try {
      const payload = {
        user_id: dataPermUser.id,
        user_email: dataPermUser.email,
        location_id: Number(dpLocation) || 0,
        channel_id: Number(dpChannel) || 0,
        show_ids: dpShows.map(Number),
        unit_ids: dpUnits.map(Number),
        status: 1,
      };
      if (isDataPermCreate) {
        await dataPermActions.createDataPermission(payload);
      } else {
        await dataPermActions.updateDataPermission(editDataPermId, {
          location_id: payload.location_id,
          channel_id: payload.channel_id,
          show_ids: payload.show_ids,
          unit_ids: payload.unit_ids,
          status: 1,
        });
      }
      toast({ description: isDataPermCreate ? 'Added data permission' : 'Updated data permission', status: 'success', duration: 3000, isClosable: true, position: 'top-right' });
      onDataPermFormClose();
      loadDataPermissions(dataPermUser.id, 0, 10, dataPermStatusFilter);
    } catch (err) {
      toast({ description: err?.response?.data?.meta?.message || err.message, status: 'error', duration: 4000, isClosable: true, position: 'top-right' });
    }
    setIsSavingDataPerm(false);
  }

  async function toggleDataPermStatus(perm) {
    try {
      const newStatus = perm.status === 1 ? 2 : 1;
      await dataPermActions.patchDataPermissionStatus(perm.id, newStatus);
      loadDataPermissions(dataPermUser.id, 0, 10, dataPermStatusFilter);
    } catch (err) {
      toast({ description: err?.response?.data?.meta?.message || err.message, status: 'error', duration: 4000, isClosable: true, position: 'top-right' });
    }
  }

  function openAddDelegate() {
    setDelegateMemberSelected(null);
    setDelegateNewStatus(1);
    setDelegateUserOptions([]);
    setDelegateUserOffset(0);
    setDelegateUserHasMore(true);
    delegateUserSearchQuery.current = '';
    onAddDelegateOpen();
  }

  async function fetchDelegateUsers(query, offset) {
    setIsLoadingDelegateUsers(true);
    const res = await reportPermActions.searchUsers(query, offset, DELEGATE_USER_PAGE_SIZE);
    const data = res?.data?.data || [];
    const total = res?.data?.meta?.total || 0;
    // hasMore dựa trên data thô từ API (trước filter) để tránh gọi thừa
    const hasMore = offset + data.length < total;
    // Lọc bỏ các user đã là delegate (bất kể status)
    const existingMemberIds = new Set(delegateList.map((d) => d.member_id));
    const existingMemberEmails = new Set(delegateList.map((d) => d.member_email));
    const mapped = data
      .filter((u) => !existingMemberIds.has(u.id) && !existingMemberEmails.has(u.email))
      .map((u) => ({ ...u, label: `${u.fullname || ''} (${u.email})`, value: u.id }));
    setIsLoadingDelegateUsers(false);
    return { mapped, hasMore };
  }

  async function onDelegateUserMenuOpen() {
    delegateUserSearchQuery.current = '';
    setDelegateUserOffset(0);
    setDelegateUserOptions([]);
    setDelegateUserHasMore(true);
    const { mapped, hasMore } = await fetchDelegateUsers('', 0);
    setDelegateUserOptions(mapped);
    setDelegateUserHasMore(hasMore);
    setDelegateUserOffset(DELEGATE_USER_PAGE_SIZE);
  }

  function onDelegateUserInputChange(inputValue, { action }) {
    if (action === 'set-value' || action === 'menu-close' || action === 'input-blur') return;
    delegateUserSearchQuery.current = inputValue;
    clearTimeout(delegateUserInputTimer.current);
    delegateUserInputTimer.current = setTimeout(async () => {
      setDelegateUserOffset(0);
      setDelegateUserOptions([]);
      setDelegateUserHasMore(true);
      const { mapped, hasMore } = await fetchDelegateUsers(inputValue, 0);
      setDelegateUserOptions(mapped);
      setDelegateUserHasMore(hasMore);
      setDelegateUserOffset(DELEGATE_USER_PAGE_SIZE);
    }, 300);
  }

  async function onDelegateUserMenuScrollToBottom() {
    if (!delegateUserHasMore || isLoadingDelegateUsers) return;
    setIsLoadingDelegateUsers(true);
    const { mapped, hasMore } = await fetchDelegateUsers(delegateUserSearchQuery.current, delegateUserOffset);
    setDelegateUserOptions((prev) => [...prev, ...mapped]);
    setDelegateUserHasMore(hasMore);
    setDelegateUserOffset((prev) => prev + DELEGATE_USER_PAGE_SIZE);
  }

  async function saveDelegate() {
    if (!delegateMemberSelected) return;
    setIsSavingDelegate(true);
    try {
      await dataPermActions.createDelegate({
        manager_id: dataPermUser.id,
        manager_email: dataPermUser.email,
        member_id: delegateMemberSelected.id,
        member_email: delegateMemberSelected.email,
        status: delegateNewStatus,
      });
      toast({ description: 'Added delegate', status: 'success', duration: 3000, isClosable: true, position: 'top-right' });
      onAddDelegateClose();
      setDelegateMemberSelected(null);
      loadDelegates(dataPermUser.id, 0, 10, delegateStatusFilter);
    } catch (err) {
      toast({ description: err?.response?.data?.meta?.message || err.message, status: 'error', duration: 4000, isClosable: true, position: 'top-right' });
    }
    setIsSavingDelegate(false);
  }

  async function toggleDelegateStatus(delegate) {
    try {
      const newStatus = delegate.status === 1 ? 2 : 1;
      await dataPermActions.patchDelegateStatus(delegate.id, newStatus);
      loadDelegates(dataPermUser.id, 0, 10, delegateStatusFilter);
    } catch (err) {
      toast({ description: err?.response?.data?.meta?.message || err.message, status: 'error', duration: 4000, isClosable: true, position: 'top-right' });
    }
  }

  const {
    isOpen: isResetOpen,
    onOpen: onResetOpen,
    onClose: onResetClose,
  } = useDisclosure();
  const [resetTargetId, setResetTargetId] = useState(null);
  const [isResetting, setIsResetting] = useState(false);
  const resetCancelRef = useRef();

  const resetPassWord = (id) => {
    setResetTargetId(id);
    onResetOpen();
  };

  const confirmResetPassword = async () => {
    setIsResetting(true);
    try {
      await userActions.resetPassword(resetTargetId);
      toast({
        description: 'Reset Password successful',
        status: 'success',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      });
    } catch (err) {
      toast({
        description: 'Reset Password not successful',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top-right',
      });
    }
    setIsResetting(false);
    onResetClose();
  };

  return (
    <Card px='0px'>
      <CardHeader px='22px' mb='12px'>
        <Flex direction='column' display='block'>
          <Text
            float='left'
            color={textColor}
            fontSize='lg'
            fontWeight='bold'
            mb='6px'
          >
            User Management
          </Text>
          <Stack float='right' direction='row' spacing={4}>
            {checkForbidden(38) && (
              <Button
                size='sm'
                onClick={() => {
                  onOpen();
                  setIsCreate(true);
                }}
                leftIcon={<AddIcon />}
                colorScheme='blue'
                variant='outline'
              >
                Add User
              </Button>
            )}
          </Stack>
          <Modal
            closeOnOverlayClick={false}
            isOpen={isOpen}
            onClose={() => {
              onClose();
              reset();
              setValue('roles', []);
              setValue('sites', []);
            }}
            size='3xl'
          >
            <ModalOverlay />
            <form onSubmit={handleSubmit(onSubmit)}>
              <ModalContent>
                <ModalHeader>
                  {isCreate ? 'Create New User' : 'Edit User'}
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                  <Grid
                    gap='16px'
                    templateColumns={{ lg: 'repeat(2, 1fr)', sm: '1fr' }}
                    mb='16px'
                  >
                    <FormControl isRequired>
                      <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                        Email
                      </FormLabel>
                      <Input
                        fontSize='sm'
                        ms='4px'
                        type='text'
                        placeholder='Email'
                        size='md'
                        name='email'
                        {...register('email')}
                        isInvalid={errors.email}
                        errorBorderColor='red.300'
                        disabled={!isCreate}
                      />
                      <Text color='red' fontSize={14} mt='4px' ml='5px'>
                        {errors.email?.message}
                      </Text>
                    </FormControl>
                    <FormControl isRequired>
                      <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                        Full Name
                      </FormLabel>
                      <Input
                        fontSize='sm'
                        ms='4px'
                        type='text'
                        placeholder='Full Name'
                        size='md'
                        name='fullname'
                        {...register('fullname')}
                        isInvalid={errors.fullname}
                        errorBorderColor='red.300'
                      />
                      <Text color='red' fontSize={14} mt='4px' ml='5px'>
                        {errors.fullname?.message}
                      </Text>
                    </FormControl>
                  </Grid>
                  <Grid
                    gap='16px'
                    templateColumns={{ lg: 'repeat(2, 1fr)', sm: '1fr' }}
                    mb='16px'
                  >
                    <FormControl isRequired>
                      <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                        Phone
                      </FormLabel>
                      <Input
                        fontSize='sm'
                        ms='4px'
                        type='number'
                        placeholder='Phone'
                        size='md'
                        name='phone'
                        {...register('phone')}
                        isInvalid={errors.phone}
                        errorBorderColor='red.300'
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                      <Text color='red' fontSize={14} mt='4px' ml='5px'>
                        {errors.phone?.message}
                      </Text>
                    </FormControl>
                    <FormControl>
                      <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                        Department
                      </FormLabel>
                      <Input
                        fontSize='sm'
                        ms='4px'
                        type='text'
                        placeholder='Department'
                        size='md'
                        name='department'
                        {...register('department')}
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    gap='16px'
                    templateColumns={{ lg: 'repeat(2, 1fr)', sm: '1fr' }}
                    mb='16px'
                  >
                    <FormControl isRequired>
                      <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                        Roles
                      </FormLabel>
                      <Controller
                        name='roles'
                        control={control}
                        render={({ field }) => (
                          <ReactSelect
                            {...field}
                            isMulti
                            options={roles}
                            placeholder='Select roles...'
                            size='sm'
                            colorScheme='blue'
                            focusBorderColor='blue.500'
                            chakraStyles={chakraStyles}
                            getOptionLabel={(op) => op.name}
                            getOptionValue={(option) => option.id}
                            closeMenuOnSelect={false}
                            className='chakra-select__input'
                          />
                        )}
                      />
                      <Text color='red' fontSize={14} mt='4px' ml='5px'>
                        {errors.roles?.message}
                      </Text>
                    </FormControl>
                    <FormControl isRequired>
                      <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>
                        Site Access
                      </FormLabel>
                      <Controller
                        name='sites'
                        control={control}
                        render={({ field }) => (
                          <ReactSelect
                            {...field}
                            isMulti
                            options={sites}
                            placeholder='Select sites...'
                            size='sm'
                            colorScheme='blue'
                            focusBorderColor='blue.500'
                            chakraStyles={chakraStyles}
                            getOptionLabel={(op) => op.name}
                            getOptionValue={(option) => option.id}
                            closeMenuOnSelect={false}
                            className='chakra-select__input'
                          />
                        )}
                      />
                      <Text color='red' fontSize={14} mt='4px' ml='5px'>
                        {errors.sites?.message}
                      </Text>
                    </FormControl>
                  </Grid>
                  <FormControl>
                    <Switch
                      id='isChecked'
                      defaultChecked={isCreate && true}
                      name='isActive'
                      {...register('isActive')}
                      size='sm'
                      ms='4px'
                    >
                      Active
                    </Switch>
                  </FormControl>
                  <Text color='red' mt='8px' ml='5px'>
                    {errors.apiError && errors.apiError?.message}
                  </Text>
                </ModalBody>
                <ModalFooter pt='0'>
                  <Button
                    colorScheme='blue'
                    mr={3}
                    type='submit'
                    isLoading={isSubmitting}
                    disabled={isSubmitting}
                  >
                    {isCreate ? 'Create' : 'Update'}
                  </Button>
                  <Button
                    onClick={() => {
                      onClose();
                      reset();
                      setValue('roles', []);
                      setValue('sites', []);
                    }}
                  >
                    Cancel
                  </Button>
                </ModalFooter>
              </ModalContent>
            </form>
          </Modal>
        </Flex>
      </CardHeader>
      <CardBody>
        <Card>
          <form
            id='user-search-form'
            onSubmit={handleSubmitSearch(onSubmitSearch)}
          >
            <Flex
              direction='row'
              alignItems='center'
              mb={3}
              gap={4}
              flexWrap={'wrap'}
            >
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel ms='4px' fontSize='xs' fontWeight='semibold'>
                  Full Name
                </FormLabel>
                <Input
                  _placeholder={{ color: 'gray.400' }}
                  variant='main'
                  type='text'
                  placeholder='Full Name'
                  minW='80px'
                  maxW='185px'
                  size='sm'
                  fontSize='sm'
                  name='fullnameSearch'
                  {...registerSearch('fullnameSearch')}
                  _focus={{ borderColor: 'blue.500' }}
                />
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel ms='4px' fontSize='xs' fontWeight='semibold'>
                  Email
                </FormLabel>
                <Input
                  _placeholder={{ color: 'gray.400' }}
                  variant='main'
                  type='text'
                  placeholder='Email'
                  minW='80px'
                  maxW='185px'
                  size='sm'
                  fontSize='sm'
                  name='emailSearch'
                  {...registerSearch('emailSearch')}
                  _focus={{ borderColor: 'blue.500' }}
                />
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                  Status
                </FormLabel>
                <Select
                  ms='4px'
                  type='text'
                  defaultValue='1'
                  size='sm'
                  name='statusSearch'
                  {...registerSearch('statusSearch')}
                  width='100px'
                >
                  {UserStatus.map((item, index) => (
                    <option key={index} value={item.Id}>
                      {item.Name}
                    </option>
                  ))}
                </Select>
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel fontWeight='semibold' fontSize='xs' ms='4px'>
                  Site
                </FormLabel>
                <Select
                  ms='4px'
                  type='text'
                  defaultValue=''
                  size='sm'
                  name='typeSearch'
                  {...registerSearch('typeSearch')}
                  width='120px'
                >
                  {UserTypeOptions.map((item, index) => (
                    <option key={index} value={item.Id}>
                      {item.Name}
                    </option>
                  ))}
                </Select>
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <FormLabel
                  htmlFor='role-search-lbl'
                  fontWeight='semibold'
                  fontSize='xs'
                  ms='4px'
                >
                  Role
                </FormLabel>
                <Controller
                  name='roleSearch'
                  control={controlSearch}
                  render={({ field }) => (
                    <ReactSelect
                      {...field}
                      isMulti
                      options={roles}
                      placeholder='Select roles...'
                      size='sm'
                      colorScheme='blue'
                      focusBorderColor='blue.500'
                      chakraStyles={chakraStyles}
                      getOptionLabel={(op) => op.name}
                      getOptionValue={(option) => option.id}
                      closeMenuOnSelect={false}
                      className='chakra-select__input'
                    />
                  )}
                />
              </Box>
            </Flex>
            <Flex justify='center' align='center' gap='8px' mt={3}>
              <Box direction='row' alignItems='center' display='block'>
                <Button
                  leftIcon={<RxReset />}
                  variant='primary'
                  w='88px'
                  h='33px'
                  onClick={() => {
                    resetSearch();
                    setValueSearch('roleSearch', null);
                  }}
                >
                  Reset
                </Button>
              </Box>
              <Box direction='row' alignItems='center' display='block'>
                <Button
                  leftIcon={<BsSearch />}
                  variant='primary'
                  w='88px'
                  h='33px'
                  type='submit'
                >
                  Search
                </Button>
              </Box>
            </Flex>
          </form>
        </Card>
        <SearchTable2
          tableData={newUser}
          columnsData={columnsDataUser}
          totalRow={totalRows.users}
          loadData={(fetchDataOptions) => recallApi(fetchDataOptions)}
          listPermissions={[39]}
          actionsActive={['resetPassword', 'detail', 'edit', 'reportPermission', 'dataPermission']}
          isFetching={isFetching}
          edit={edit}
          resetPassWord={resetPassWord}
          showDetail={showDetail}
          refreshPagingDefault={refreshPagingDefault}
          reportPermission={openReportPermModal}
          reportPermissionIds={[142]}
          dataPermission={openDataPermModal}
          dataPermissionIds={[146]}
        />

        {/* Reset Password Confirmation Dialog */}
        <AlertDialog
          isOpen={isResetOpen}
          leastDestructiveRef={resetCancelRef}
          onClose={onResetClose}
          isCentered
        >
          <AlertDialogOverlay>
            <AlertDialogContent bg='white' borderRadius='12px' px={3} py={3} maxW='320px' w='90%' mx={4}>
              <IconButton
                aria-label='Close dialog'
                icon={<CloseIcon boxSize={2} />}
                position='absolute'
                top={2}
                right={2}
                onClick={onResetClose}
                borderRadius='full'
                border='1px solid'
                borderColor='gray.200'
                bg='white'
                _hover={{ bg: 'gray.50' }}
                size='xs'
                minW='24px'
                h='24px'
              />
              <AlertDialogHeader fontSize='lg' fontWeight='700' color='#0DB34A' textAlign='left' pb={1} pt={1}>
                Reset Password
              </AlertDialogHeader>
              <AlertDialogBody py={2} color='gray.700' fontSize='sm' textAlign='left'>
                Are you sure you want to reset the password for this user?
              </AlertDialogBody>
              <AlertDialogFooter pt={2} pb={1}>
                <Button
                  ref={resetCancelRef}
                  onClick={onResetClose}
                  bg='gray.100'
                  _hover={{ bg: 'gray.200' }}
                  color='gray.800'
                  borderRadius='8px'
                  px={3}
                  size='sm'
                  h='32px'
                >
                  Cancel
                </Button>
                <Button
                  bg='#053957'
                  color='white'
                  ml={2}
                  isLoading={isResetting}
                  onClick={confirmResetPassword}
                  _hover={{ bg: '#042e45' }}
                  borderRadius='8px'
                  px={3}
                  size='sm'
                  h='32px'
                >
                  Confirm
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>

        {/* Report Permission Modal */}
        <Modal isOpen={isPermOpen} onClose={onPermClose} size='4xl' closeOnOverlayClick={false} scrollBehavior='inside'>
          <ModalOverlay />
          <ModalContent maxH='80vh'>
            <ModalHeader>User Report Permissions — {permUser?.fullname || permUser?.email}</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={4} overflow='auto'>
              <Box maxH='50vh'>
                <SearchTable2
                  tableData={reports}
                  columnsData={columnsDataReportPerm}
                  totalRow={reportTotal}
                  loadData={recallReportsForPerm}
                  actionsActive={[]}
                  listPermissions={[]}
                  isFetching={isFetchingReports}
                  enableSorting={false}
                  tableMeta={{ permMap, togglePerm }}
                />
              </Box>
            </ModalBody>
            <ModalFooter>
              {(checkForbidden(144) || checkForbidden(145)) && (
                <Button colorScheme='blue' mr={3} size='sm' isLoading={isSavingPerm} onClick={saveReportPerms}>Save</Button>
              )}
              <Button size='sm' onClick={onPermClose}>Cancel</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        {/* Data Permission Modal */}
        <Modal isOpen={isDataPermOpen} onClose={onDataPermClose} size='6xl' closeOnOverlayClick={false} scrollBehavior='inside'>
          <ModalOverlay />
          <ModalContent maxH='80vh'>
            <ModalHeader>Data Permission - {dataPermUser?.fullname || dataPermUser?.email}</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={4} overflow='auto'>
              <Tabs variant='enclosed' colorScheme='blue'>
                <TabList>
                  <Tab>Data Permission</Tab>
                  <Tab>Delegates</Tab>
                </TabList>
                <TabPanels>
                  {/* Tab 1: Data Permission */}
                  <TabPanel px={0} pt={3}>
                    <Flex justify='space-between' align='center' mb={3}>
                      <Flex align='center' gap={3}>
                        <Text fontSize='sm' fontWeight='semibold'>Status:</Text>
                        <Select
                          size='sm'
                          width='120px'
                          value={dataPermStatusFilter}
                          onChange={(e) => {
                            setDataPermStatusFilter(e.target.value);
                            loadDataPermissions(dataPermUser.id, 0, 10, e.target.value);
                          }}
                        >
                          <option value='0'>All</option>
                          <option value='1'>Active</option>
                          <option value='2'>InActive</option>
                        </Select>
                      </Flex>
                      {checkForbidden(148) && (
                        <Button size='sm' colorScheme='blue' variant='outline' leftIcon={<AddIcon />} onClick={openAddDataPerm}>
                          Add
                        </Button>
                      )}
                    </Flex>
                    <SearchTable2
                      tableData={dataPermList}
                      columnsData={[
                        { header: 'Location', accessorKey: 'location_name', Cell: ({ cell }) => cell.getValue() || 'All' },
                        { header: 'Channel', accessorKey: 'channel_name', Cell: ({ cell }) => cell.getValue() || 'All' },
                        { header: 'Shows', accessorKey: 'show_names', Cell: ({ cell }) => { const v = cell.getValue(); if (!v || v.length === 0) return 'All'; return (
                          <Box maxH='80px' whiteSpace='normal' lineHeight='1.4' sx={{ overflowY: 'scroll', '&::-webkit-scrollbar': { display: 'block', width: '6px' }, '&::-webkit-scrollbar-thumb': { background: 'gray.300', borderRadius: '4px' } }}>
                            {v.map((name, i) => <div key={i}>{name}</div>)}
                          </Box>
                        ); } },
                        { header: 'Units', accessorKey: 'unit_names', Cell: ({ cell }) => { const v = cell.getValue(); if (!v || v.length === 0) return 'All'; return (
                          <Box maxH='80px' whiteSpace='normal' lineHeight='1.4' sx={{ overflowY: 'scroll', '&::-webkit-scrollbar': { display: 'block', width: '6px' }, '&::-webkit-scrollbar-thumb': { background: 'gray.300', borderRadius: '4px' } }}>
                            {v.map((name, i) => <div key={i}>{name}</div>)}
                          </Box>
                        ); } },
                        { header: 'Status', accessorKey: 'status', size: 80, Cell: ({ row, table }) => (
                          <Switch size='sm' isChecked={row.original.status === 1} colorScheme='blue' isDisabled={!checkForbidden(149)} onChange={() => checkForbidden(149) && table.options.meta?.toggleStatus(row.original)} />
                        )},
                      ]}
                      totalRow={dataPermTotal}
                      loadData={(opts) => loadDataPermissions(dataPermUser.id, opts.pageIndex, opts.pageSize, dataPermStatusFilter)}
                      actionsActive={checkForbidden(149) ? ['edit'] : []}
                      listPermissions={[39]}
                      isFetching={isFetchingDataPerm}
                      edit={(id) => openEditDataPerm(dataPermList.find((p) => p.id === id))}
                      enableSorting={false}
                      tableMeta={{ toggleStatus: toggleDataPermStatus }}
                    />
                  </TabPanel>

                  {/* Tab 2: Delegates */}
                  <TabPanel px={0} pt={3}>
                    <Flex justify='space-between' align='center' mb={3}>
                      <Flex align='center' gap={3}>
                        <Text fontSize='sm' fontWeight='semibold'>Status:</Text>
                        <Select
                          size='sm'
                          width='120px'
                          value={delegateStatusFilter}
                          onChange={(e) => {
                            setDelegateStatusFilter(e.target.value);
                            loadDelegates(dataPermUser.id, 0, 10, e.target.value);
                          }}
                        >
                          <option value='0'>All</option>
                          <option value='1'>Active</option>
                          <option value='2'>InActive</option>
                        </Select>
                      </Flex>
                      {checkForbidden(148) && (
                        <Button size='sm' colorScheme='blue' variant='outline' leftIcon={<AddIcon />} onClick={openAddDelegate}>
                          Add
                        </Button>
                      )}
                    </Flex>
                    <Box minW='400px'>
                      <SearchTable2
                        tableData={delegateList}
                        columnsData={[
                          { header: 'Member Email', accessorKey: 'member_email', minSize: 200 },
                          { header: 'Status', accessorKey: 'status', size: 80, Cell: ({ row, table }) => (
                            <Switch size='sm' isChecked={row.original.status === 1} colorScheme='blue' isDisabled={!checkForbidden(149)} onChange={() => checkForbidden(149) && table.options.meta?.toggleStatus(row.original)} />
                          )},
                        ]}
                        totalRow={delegateTotal}
                        loadData={(opts) => loadDelegates(dataPermUser.id, opts.pageIndex, opts.pageSize, delegateStatusFilter)}
                        actionsActive={[]}
                        listPermissions={[]}
                        isFetching={isFetchingDelegates}
                        enableSorting={false}
                        tableMeta={{ toggleStatus: toggleDelegateStatus }}
                      />
                    </Box>
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </ModalBody>
            <ModalFooter>
              <Button size='sm' onClick={onDataPermClose}>Close</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Add Delegate Modal */}
        <Modal isOpen={isAddDelegateOpen} onClose={() => { onAddDelegateClose(); setDelegateMemberSelected(null); }} size='md' closeOnOverlayClick={false}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Add Delegate</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={4}>
              <FormControl mb={3}>
                <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>Member (search by email)</FormLabel>
                <ReactSelect
                  value={delegateMemberSelected}
                  onChange={(u) => setDelegateMemberSelected(u)}
                  options={delegateUserOptions}
                  placeholder='Search user by email...'
                  getOptionLabel={(u) => u.label}
                  getOptionValue={(u) => u.id}
                  size='sm'
                  isClearable
                  isLoading={isLoadingDelegateUsers}
                  filterOption={() => true}
                  closeMenuOnSelect
                  onMenuOpen={onDelegateUserMenuOpen}
                  onInputChange={onDelegateUserInputChange}
                  onMenuScrollToBottom={onDelegateUserMenuScrollToBottom}
                  chakraStyles={{ menu: (p) => ({ ...p, zIndex: 10 }) }}
                />
              </FormControl>
              <FormControl>
                <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>Status</FormLabel>
                <Select size='sm' value={delegateNewStatus} onChange={(e) => setDelegateNewStatus(Number(e.target.value))}>
                  <option value={1}>Active</option>
                  <option value={2}>Inactive</option>
                </Select>
              </FormControl>
            </ModalBody>
            <ModalFooter>
              {checkForbidden(148) && (
                <Button colorScheme='blue' size='sm' mr={3} isLoading={isSavingDelegate} onClick={saveDelegate} isDisabled={!delegateMemberSelected}>Create</Button>
              )}
              <Button size='sm' onClick={() => { onAddDelegateClose(); setDelegateMemberSelected(null); }}>Cancel</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* Add/Edit Data Permission Modal */}
        <Modal isOpen={isDataPermFormOpen} onClose={onDataPermFormClose} size='2xl' closeOnOverlayClick={false}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{isDataPermCreate ? 'Add Data Permission' : 'Edit Data Permission'}</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={4}>
              {/* Row 1: Location | Shows */}
              <Grid gap='16px' templateColumns='repeat(2, 1fr)' mb='16px'>
                <FormControl>
                  <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>Location</FormLabel>
                  <Select size='sm' value={dpLocation} onChange={(e) => setDpLocation(e.target.value)}>
                    <option value='0'>All</option>
                    {locationList.map((loc) => (
                      <option key={loc.id} value={String(loc.id)}>{loc.name}</option>
                    ))}
                  </Select>
                </FormControl>
                <FormControl>
                  <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>Shows</FormLabel>
                  <Checkbox
                    size='sm'
                    mb={1}
                    fontWeight='semibold'
                    isChecked={dpShows.length === 0}
                    onChange={(e) => { if (e.target.checked) setDpShows([]); }}
                  >
                    All
                  </Checkbox>
                  <Box
                    border='1px solid'
                    borderColor='gray.200'
                    borderRadius='md'
                    maxH='180px'
                    sx={{ overflowY: 'scroll', '&::-webkit-scrollbar': { display: 'block', width: '6px' }, '&::-webkit-scrollbar-thumb': { background: 'gray.300', borderRadius: '4px' } }}
                  >
                    <Stack spacing={0} px={2} py={1}>
                      {showList.map((show) => (
                        <Checkbox
                          key={show.id}
                          size='sm'
                          py='3px'
                          isChecked={dpShows.includes(show.id)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setDpShows((prev) => {
                                const next = [...prev, show.id];
                                return next.length === showList.length ? [] : next;
                              });
                            } else {
                              setDpShows((prev) => prev.filter((id) => id !== show.id));
                            }
                          }}
                        >
                          {show.name}
                        </Checkbox>
                      ))}
                    </Stack>
                  </Box>
                </FormControl>
              </Grid>
              {/* Row 2: Channel | Units */}
              <Grid gap='16px' templateColumns='repeat(2, 1fr)' mb='12px'>
                <FormControl>
                  <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>Channel</FormLabel>
                  <Select size='sm' value={dpChannel} onChange={(e) => onDataPermChannelChange(e.target.value)}>
                    <option value='0'>All</option>
                    {channelList.map((ch) => (
                      <option key={ch.id} value={String(ch.id)}>{ch.name}</option>
                    ))}
                  </Select>
                </FormControl>
                {dpChannel && dpChannel !== '0' && (
                  <FormControl>
                    <FormLabel ms='4px' fontSize='sm' fontWeight='normal'>Units</FormLabel>
                    <Input
                      size='sm'
                      placeholder='Search units...'
                      value={unitSearch}
                      mb={1}
                      onChange={(e) => onUnitSearch(dpChannel, e.target.value)}
                    />
                    <Box
                      border='1px solid'
                      borderColor='gray.200'
                      borderRadius='md'
                      maxH='180px'
                      overflowY='scroll'
                      onScroll={(e) => {
                        const el = e.currentTarget;
                        if (unitHasMore && !isFetchingUnits && el.scrollTop + el.clientHeight >= el.scrollHeight - 8) {
                          onUnitLoadMore(dpChannel);
                        }
                      }}
                    >
                      {unitList.length === 0 && !isFetchingUnits && (
                        <Text fontSize='sm' color='gray.400' px={3} py={2}>No units</Text>
                      )}
                      <Stack spacing={0} px={2} py={1}>
                        <Checkbox
                          size='sm'
                          py='3px'
                          fontWeight='semibold'
                          isChecked={dpUnits.length === 0}
                          onChange={(e) => { if (e.target.checked) setDpUnits([]); }}
                        >
                          All
                        </Checkbox>
                        {unitList.map((unit) => (
                          <Checkbox
                            key={unit.id}
                            size='sm'
                            py='3px'
                            isChecked={dpUnits.includes(unit.id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setDpUnits((prev) => {
                                  const next = [...prev, unit.id];
                                  return !unitHasMore && next.length === unitList.length ? [] : next;
                                });
                              } else {
                                setDpUnits((prev) => prev.filter((id) => id !== unit.id));
                              }
                            }}
                          >
                            {unit.name}
                          </Checkbox>
                        ))}
                      </Stack>
                      {isFetchingUnits && (
                        <Text fontSize='xs' color='gray.400' textAlign='center' py={2}>Loading...</Text>
                      )}
                    </Box>
                  </FormControl>
                )}
              </Grid>
            </ModalBody>
            <ModalFooter>
              {(isDataPermCreate ? checkForbidden(148) : checkForbidden(149)) && (
                <Button colorScheme='blue' size='sm' mr={3} isLoading={isSavingDataPerm} onClick={saveDataPerm}>Save</Button>
              )}
              <Button size='sm' onClick={onDataPermFormClose}>Cancel</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>


      </CardBody>
    </Card>
  );
}

export default DataTablesUser;
